import * as yup from "yup";

export const CreateSubscriptionFormValidation = yup.object().shape({
    level: yup.number().typeError("Deve ser um número")
    .required('Ano é obrigatório')
    .positive('Deve ser maior que zero'),
    semester: yup.number().typeError("Deve ser um número")
    .required('Semestre é obrigatório')
   // .positive('Deve ser maior que zero')
    .oneOf([1, 2], 'Semestre deve ser 1 ou 2'),
    year: yup.number().typeError("Deve ser um número")
    .required('Ano é obrigatório')
    .positive('Deve ser maior que zero'),
    subjects: yup.array().optional()
  });